import React from 'react'
import Card from '../components/Card'
import { useTranslation } from 'react-i18next';

const Aboutme = () => {
    const [t] = useTranslation("global");
    return (
        <section className="Aboutme" id='Aboutme'>
            <h1 className='Aboutme_title'>{t("Aboutme")}</h1>
            <div className='Aboutme-container'>
                <div className='tilt-container'>
                    <Card className="Card"/>
                </div>
            </div>
        </section>
    )
}

export default Aboutme
